import axios from 'axios';

const baseURL = process.env.REACT_APP_ENDPOINT;
const api = axios.create({
  baseURL,
});

export default api;
